import { getPublicConfig } from "../api/config/getPublicConfig";
import { getMyUser } from "../api/user/getMyUser";
import { isAIConsentPromptEnabled } from "../helpers/configuration";
import { useAuth } from "../providers/AuthProvider";

// useAIConsent.ts
export const useAIConsent = () => {
  const { inAppScope } = useAuth();
  const configMap = getPublicConfig();
  const myUser = getMyUser();

  // Centralise the logic here
  const consentPromptEnabled =
    configMap.isSuccess && isAIConsentPromptEnabled(configMap.data);
  const userHasConsented = myUser.isSuccess && myUser.data?.aiConsent;

  const shouldPromptForAIConsent =
    inAppScope("external") && consentPromptEnabled && !userHasConsented;

  return {
    shouldPrompt: !!shouldPromptForAIConsent,
    isLoading: configMap.isLoading || myUser.isLoading,
  };
};
